<mat-dialog-content>
    <div class="container">
        <form>
            <h2>{{ 'SENDING-DOCUMENTS.TO_ANOTHER_CSR.TITLE' | translate }}</h2>
            <div class="table-responsive-wrapper">
                <br />
                <table mat-table id="myTable" #myTable [dataSource]="dataSource">
                    <ng-container matColumnDef="csr">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'GLOBAL.CENTER' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.csrName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="numberOfDocuments">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'SENDING-DOCUMENTS.TO_ANOTHER_CSR.NUMBER_OF_DOCUMENTS' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ element?.papers.length }}

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element; let i = index"
                            class="table__cell table__cell--align-right">
                            <button mat-icon-button class="button-square table__row-button" color="primary"
                                type="button" matTooltip="{{ 'SUBJECTS.MORE_TOOLTIP' | translate }}"
                                [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                (click)="$event.stopPropagation()">
                                <mat-icon class="button-square__icon">more_horiz</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" class="filter-menu">
                                <button mat-menu-item type="button" (click)="removeReceiver(i)">

                                    <mat-icon class="button-square__icon">delete</mat-icon>
                                    {{ 'GLOBAL.REMOVE' | translate }}
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="subjects__row--header"></tr>
                    <tr mat-row *matRowDef="let element; let row;let index; columns: displayedColumns"
                        class="subjects__row">
                    </tr>
                </table>
            </div>
            <div class="button-add-holder">
                <button mat-flat-button color="primary" type="button" (click)="addReciverToList()">
                    <mat-icon>person_add</mat-icon>
                    {{ "SENDING-DOCUMENTS.TO_ANOTHER_CSR.SELECT_CENTER" | translate }}
                </button>
            </div>
            <br />
            <form-footer>
                <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()" type="button"
                    class="form-footer__button form-footer__button--secondary">
                    {{ 'SENDING-DOCUMENTS.CANCEL' | translate }}
                </button>
                <button mat-flat-button color="primary" (click)="sendDocument()" [disabled]="isSending||dataForSendingDocuments.deliveries.length===0" type="button"
                    class="form-footer__button form-footer__button--primary"
                    [disabled]="dataForSendingDocuments.deliveries.length===0">
                    {{ 'SENDING-DOCUMENTS.TO_ANOTHER_CSR.SEND' | translate }}
                </button>
                <mat-progress-spinner [diameter]="45" *ngIf="isSending" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </form-footer>
        </form>
        <br />
    </div>
</mat-dialog-content>